import WYSIWYGContent from 'components/WYSIWYGContent';

function DescriptionPreview({ formValues }: PreviewComponentProps<ContentContainer>) {
  return <WYSIWYGContent content={formValues?.content ?? ''} placeholder="Tu pojawi się Twój opis" />;
}

export default DescriptionPreview;
